import React from "react";
// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";

import Section1 from "../includes/Intelihire/Section1";
import Section2 from "../includes/Intelihire/Section2";
import Section3 from "../includes/Intelihire/Section3";
import Section4 from "../includes/Intelihire/Section4";
import Section5 from "../includes/Intelihire/Section5";
import Section6 from "../includes/Intelihire/Section6";
import Section7 from "../includes/Intelihire/Section7";
import Section8 from "../includes/Intelihire/Section8";

const Intelihire = ({ devUrl }) => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.exddigital.com/intelihire",
    },
    name: "Intelihire AI",
    headline: "Hire The Right Talent with AI Recruiting Software",
    image: "https://www.exddigital.com/images/exd_digital.webp",
    author: {
      "@type": "Organization",
      name: "ExD Digital",
      url: "https://www.exddigital.com",
    },
    publisher: {
      "@type": "Organization",
      name: "ExD Digital",
      logo: {
        "@type": "ImageObject",
        url: "https://www.exddigital.com/images/exd_digital.webp",
      },
    },
    datePublished: "2026-04-15",
    dateModified: "2026-04-15",
  };

  return (
    <>
      <Helmet>
        <title>Intelihire AI</title>
        <meta
          name="description"
          content="Cut hiring time by 60% and eliminate 90% of manual screening work with our AI recruiting software."
        />
        <link rel="canonical" href="https://www.exddigital.com/intelihire" />
        <meta
          property="og:title"
          content="Intelihire AI | ExD Digital"
        />
        <meta
          property="og:description"
          content="Cut hiring time by 60% and eliminate 90% of manual screening work with our AI recruiting software."
        />
        <meta property="og:url" content="https://www.exddigital.com/intelihire" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Intelihire AI | ExD Digital"
        />
        <meta
          name="twitter:description"
          content="Cut hiring time by 60% and eliminate 90% of manual screening work with our AI recruiting software."
        />
        <meta
          name="twitter:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />
        <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>
      </Helmet>

      <main className="our-ai-main">
        <article className="intelihire">
          <Section1 url={devUrl} />
          <Section2 url={devUrl} />
          <Section3 url={devUrl} />
          <Section7 url={devUrl} />
          <Section4 url={devUrl} />
          <Section5 url={devUrl} />
          <Section6 url={devUrl} />
          <Section8 url={devUrl} />
        </article>
      </main>
    </>
  );
};

export default Intelihire;
